module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pa-5 pt-0 pb-0"
  }, [_c('v-row', {
    staticStyle: {
      "justify-content": "between"
    }
  }, [_c('v-col', {
    staticClass: "sub-title",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "mt-0",
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedFilter.search),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "search", $$v)
      },
      expression: "selectedFilter.search"
    }
  })], 1), _vm._v(" "), (_vm.isSuperAdmin || _vm.isAM) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "name",
      "label": "AM",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSuperAdmin || _vm.isCC) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.CC,
      "item-value": "id",
      "item-text": "name",
      "label": "CC",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.CC),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CC", $$v)
      },
      expression: "selectedFilter.CC"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-data-table', {
    staticClass: "drafts-data-table elevation-1",
    attrs: {
      "loading": _vm.loading,
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "search": _vm.selectedFilter.search,
      "items-per-page": 5
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-left " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('a', {
          staticClass: "custom-link",
          on: {
            "click": function($event) {
              return _vm.openCampaignModal(item.campaignID)
            }
          }
        }, [_vm._v(_vm._s(item.name || ''))])])]
      }
    }, {
      key: "item.reviewMeetingDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [(_vm.isLinkAllow) ? _c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": ("/campaigns/timeline?campaignID=" + (item.campaignID)),
            "target": '_blank'
          }
        }, [_vm._v("\n            " + _vm._s(item.reviewMeetingDate || '') + "\n          ")]) : _c('span', [_vm._v(_vm._s(item.reviewMeetingDate || ''))])])]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": '/campaign-report-internal?id=' + item.campaignID,
            "target": "_blank"
          }
        }, [_vm._v("\n            " + _vm._s(item.submittedInfs || 0) + " / " + _vm._s(item.pairingInfs || 0) + "\n          ")])])]
      }
    }, {
      key: "item.submissionDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('span', [_vm._v(_vm._s(item.submissionDate ? _vm.formatDate(item.submissionDate) : ''))])])]
      }
    }, {
      key: "item.reviewDeck",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : '')),
          staticStyle: {
            "min-width": "100px"
          }
        }, [(item.reviewDeckURL) ? _c('v-btn', _vm._g(_vm._b({
          staticClass: "btn-view-review-deck",
          attrs: {
            "href": item.reviewDeckURL,
            "target": "_blank",
            "color": "warning",
            "small": "",
            "text": ""
          }
        }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
          staticClass: "mr-0",
          attrs: {
            "x-small": "",
            "left": ""
          }
        }, [_vm._v("remove_red_eye")]), _vm._v(" "), _c('span', [_vm._v("View Review Deck")])], 1) : _c('v-btn', _vm._g(_vm._b({
          staticClass: "btn-view-review-deck",
          attrs: {
            "color": "warning",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openReviewDeckDialog(item)
            }
          }
        }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n            Add Review Deck\n          ")])], 1)]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : '')),
          staticStyle: {
            "min-width": "100px"
          }
        }, [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Close Campaign",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.proceedApproveCampaign(item.campaignID)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("power_settings_new")])], 1)], 1)]
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('review-deck-url-modal', {
    attrs: {
      "value": _vm.reviewDeckURLDialog,
      "item": _vm.reviewDeckItem,
      "dateCol": _vm.reviewDeckCol
    },
    on: {
      "saveClicked": _vm.saveReviewDeckURL
    },
    model: {
      value: (_vm.reviewDeckURLDialog),
      callback: function($$v) {
        _vm.reviewDeckURLDialog = $$v
      },
      expression: "reviewDeckURLDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21e8a53e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardComponents/ReportingDataTable.vue
// module id = 2036
// module chunks = 0